export const Routes = {
  emptyPath: '/',
  // dashboard: {
  //   path: '/dashboard',
  //   Header_text: 'Dashboard',
  //   pagename: '',
  //   id: 'dasboard',
  //   initialRoute: 'dashboard',
  // },

  login: { path: '/login', social_login_text: 'signup', id: 'login' },
  customerLogin: {
    path: '/customerlogin',
    social_login_text: 'signup',
    id: 'customerlogin',
  },
  signup: { path: '/signup', social_login_text: 'signup', id: 'SignUp' },
  otpVerify: { path: '/verification' },

  forgotPassword: {
    path: '/forgot-password',
    social_login_text: 'signup',
    id: 'ForgetPassword',
  },

  roleManagement: {
    path: '/iam/role',
    Header_text: 'Role Management',
    pagename: 'iam',
    initialRoute: '',
    intialRouteto: '/iam/role',
  },
  createRole: {
    path: '/iam/role/create',
    Header_text: 'Create Role',
    id: 'roles::create',
    pagename: 'iam',
    initialRoute: 'Role Management',
    intialRouteto: '/iam/role',
  },
  editRole: {
    path: '/iam/role/edit/:name/:id',
    Header_text: 'Edit Role',
    id: 'roles::update',
    pagename: 'iam',
    initialRoute: 'Role Management',
    intialRouteto: '/iam/role',
  },

  userManagement: {
    path: '/iam/user',
    Header_text: 'User Management',
    id: 'users::list',
    pagename: 'iam',
    initialRoute: '',
    intialRouteto: '/iam/user',
  },
  createUser: {
    path: '/iam/user/create',
    Header_text: 'Create User',
    id: 'users::create',
    pagename: 'iam',
    initialRoute: 'User Management',
    intialRouteto: '/iam/user',
  },
  editUser: {
    path: '/iam/user/edit/:name/:id',
    Header_text: 'Edit User',
    id: 'users::update',
    pagename: 'iam',
    initialRoute: 'User Management',
    intialRouteto: '/iam/user',
  },

  auditLog: {
    path: '/iam/auditlog',
    Header_text: 'Global Audit Log',
    id: 'audit::list',
    pagename: 'iam',
    initialRoute: '',
    intialRouteto: '/iam/auditlog',
  },
  auditLogUpdate: {
    path: '/auditlogupdate',
    Header_text: 'Audit Log Update',
    id: 'audit::update',
    pagename: '',
    initialRoute: 'Global Audit',
    intialRouteto: '/iam/auditlog',
  },

  editProfile: {
    path: '/editProfile',
    Header_text: 'Edit Profile',
    id: 'audit::edit',
    pagename: '',
    initialRoute: 'Global Audit',
    intialRouteto: '/iam/auditlog',
  },
  hardwareManagement: {
    path: '/hardware/controller',
    Header_text: 'Controller',
    id: 'controller::list',
    pagename: '',
    initialRoute: '',
    intialRouteto: '',
  },
  createController: {
    path: '/hardware/controller/create',
    Header_text: 'Create A Controller',
    id: 'controller::create',
    pagename: 'hardware',
    initialRoute: 'Hardware Management',
    intialRouteto: '/hardware/controller',
  },
  EditController: {
    path: '/hardware/controller/edit/:name/:id',
    Header_text: 'id',
    id: 'controller::edit',
    pagename: 'hardware',
    initialRoute: 'Hardware Management',
    intialRouteto: '/hardware/controller',
  },
  Equipments: {
    path: '/hardware/equipments',
    Header_text: 'Equipments',
    id: 'Equipments::list',
    pagename: 'hardware',
    initialRoute: 'Hardware Management',
    intialRouteto: '/hardware/controller',
  },
  CreateEquipments: {
    path: '/hardware/equipments/create',
    Header_text: 'Create A Equipments',
    id: 'Equipments::create',
    pagename: 'hardware',
    secoundHome: 'Hardware Management',
    secoundInitialRouteto: '/hardware/controller',
    initialRoute: 'Equipments',
    intialRouteto: '/hardware/equipments',
  },
  EditEquipments: {
    path: '/hardware/equipments/edit/:name/:id',
    Header_text: 'id',
    id: 'Equipments::edit',
    pagename: 'hardware',
    secoundHome: 'Hardware Management',
    secoundInitialRouteto: '/hardware/controller',
    initialRoute: 'Equipments',
    intialRouteto: '/hardware/equipments',
  },
  Category: {
    path: '/hardware/category',
    Header_text: 'Category',
    id: 'Category::list',
    pagename: 'hardware',
    initialRoute: 'Hardware Management',
    intialRouteto: '/hardware/controller',
  },
  ManufactureUnit: {
    path: '/manufacture/production',
    Header_text: 'Manufacture Unit',
  },
  ManufactureUnitCreate: {
    path: '/manufacture/production/create',
    Header_text: 'Manufacture Unit',
  },
  ManufactureUnitEdit: {
    path: '/manufacture/production/edit/:name/:id',
    Header_text: 'Edit Manufacture Unit',
    pagename: 'manufacture',
    initialRoute: 'manufacture',
    intialRouteto: '/manufacture/production',
  },
  Inventory: {
    path: '/inventory',
    Header_text: 'Inventory Management',
  },
  CustomerManagement: {
    path: '/customermanagement',
    Header_text: 'Customer Management',
  },
  CustomerManagementEdit: {
    path: '/customermanagement/edit/:name/:id',
    Header_text: 'id',
    pagename: 'Customer Management',
    initialRoute: 'Customer Management',
    intialRouteto: '/customermanagement',
  },
  EquipmentDetails: {
    path: '/customermanagement/equipmentdetails/:name/:id',
    Header_text: 'id',
    pagename: 'Customer Management',
    initialRoute: 'Customer Management',
    intialRouteto: '/customermanagement',
  },
  PersonalDetails: {
    path: '/profilemanagement/personaldetails',
    Header_text: 'Personal Details',
  },
  OrganizationDetails: {
    path: '/profilemanagement/organizationdetails',
    Header_text: 'Organization Details',
    pagename: 'Profile Management',
    initialRoute: 'Profile Management',
    intialRouteto: '/profilemanagement/personaldetails',
  },
  NotificatiopnPreference: {
    path: '/profilemanagement/notificationpreference',
    Header_text: 'Notification preference',
    pagename: 'Profile Management',
    initialRoute: 'Profile Management',
    intialRouteto: '/profilemanagement/personaldetails',
  },
  OwnedEquipments: {
    path: '/equipment/ownedequipment',
    Header_text: 'Equipment',
  },
  sharedWithMeEquipments: {
    path: '/equipment/sharedwithmeequipment',
    Header_text: 'Equipment',
  },
  OwnedEquipmentsDetails: {
    path: '/equipment/ownedequipment/details/:name/:id',
    pagename: 'equipment',
    Header_text: 'id',
    initialRoute: 'equipment',
    intialRouteto: '/equipment/ownedequipment',
    refreshAccess: true,
  },
  sharedWithMeEquipmentsDetails: {
    path: '/equipment/sharedwithmeequipment/details/:name/:id',
    Header_text: 'id',
    pagename: 'equipment',
    initialRoute: 'equipment',
    intialRouteto: '/equipment/sharedwithmeequipment',
    refreshAccess: true,
  },
  manageBilling: {
    path: '/manageBilling',
    Header_text: 'Subscription',
  },
  shareEquipments: {
    path: '/equipment/sharedwithmeequipment/share/:name/:id',
    Header_text: 'Share Equipment',
    pagename: 'equipment',
    initialRoute: 'equipment',
    intialRouteto: '/equipment/sharedwithmeequipment',
  },
  shareOwnedEquipments: {
    path: '/equipment/ownedequipment/share/:name/:id',
    Header_text: 'Share Equipment',
    pagename: 'equipment',
    initialRoute: 'equipment',
    intialRouteto: '/equipment/ownedequipment',
  },
  alert: {
    path: '/alert',
    Header_text: 'Alert',
  },
};
